import './onlineServices.scss';
declare function Translate(key: string): string;

const OnlineServices = () => {
    return (
        <div aria-hidden="true" className='onlineServicesContainer'>
            <div className='onlineServicesTitle'>{Translate('N_OnLineServices_Title')}</div>
            <div className='onlineServiceLinks'>
                <div className='myGovIcon' />
                <div className='netamishpatIcon' />
                <div className='ashraiIcon' />
                <div className='bituachIcon' />
            </div>
        </div>
    )
}
export default OnlineServices;

